/**
 * Created by Mike Naughton on 12/14/16.
 */

//fires select event that has as argument the item selected
import Backbone from "backbone";
import _ from "underscore";
export default Backbone.View.extend({
  tagName: "input",
  attributes: {
    type: "text",
    autocomplete: "off",
  },

  events: {
    blur: function () {
      var self = this;

      setTimeout(function () {
        self.clear();
      }, 200);
    },
  },

  className: "form-control typeahead-view",
  /**
   * True if the typeahead control has been mounted to the DOM, otherwise false.
   * @type {Boolean}
   */
  mounted: false,

  initialize: function (options) {
    this.options = _.defaults({}, options, {
      placeholder: "",
      source: [],
      autoSelect: false,
    });
  },

  clear: function () {
    this.$el.val("");
    var typeAheadDropDownMenu = this.$el.siblings(".typeahead");

    if (typeAheadDropDownMenu) {
      typeAheadDropDownMenu.hide();
    }
  },

  /**
   * Sets the source of the typeahead search.
   * @param source The source. See https://github.com/bassjobsen/Bootstrap-3-Typeahead for more details
   */
  setSource: function (source) {
    var self = this;

    if (this.$el.typeahead) {
      if (this.mounted) {
        this.$el.typeahead("destroy");
      }

      this.$el.typeahead(
        _.extend({}, this.options, {
          source: source,
          items: "all",
          afterSelect: function (item) {
            self.clear();

            if (item) {
              self.trigger("select", item);
            }
          },
        })
      );

      this.mounted = true;
    }
  },

  render: function () {
    this.$el.attr("placeholder", this.options.placeholder);
    this.setSource(this.options.source);
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/TypeaheadView.js
// module id = 944
// module chunks = 1